import { CustomError } from '../../common/errors';
import Result from '../../common/result';

export enum EmailErrorType {
  /// Incorrect Email
  email = 'email',
  /// Incorrect Token
  token = 'token',
  /// Error performing network operation
  network = 'network',
  /// Generic error
  generic = 'generic',
  /// No more retries remaining
  retriesExhausted = 'retriesExhausted',
}

export class EmailError extends Error {
  errorType: EmailErrorType;

  error: CustomError | null;

  constructor(errorType: EmailErrorType, error?: CustomError) {
    super('Email error');
    this.errorType = errorType;
    this.error = error || null;
  }
}
export function emailNetworkError(error: CustomError): EmailError {
  return new EmailError(EmailErrorType.network, error);
}

export function emailGenericError(): EmailError {
  return new EmailError(EmailErrorType.generic);
}

export function emailFormatValidationError(): EmailError {
  return new EmailError(EmailErrorType.email);
}

export function emailTokenVericationError(): EmailError {
  return new EmailError(EmailErrorType.token);
}

export function emailRetriesExhaustedError(): EmailError {
  return new EmailError(EmailErrorType.retriesExhausted);
}

export type EmailResult = Result<EmailError>;
